import React from 'react';

import CreateAppointmentSuccess from 'modules/appointmentsManagement/components/CreateAppointment/components/CreateAppointmentSuccess';

const CreateAppointmentSuccessPage = () => {
  return (
    <CreateAppointmentSuccess />
  );
};

export default CreateAppointmentSuccessPage;
